export default {
  gutterBottom: {
    marginBottom: '8px !important',
  },
};
